// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rg-0";